import { FaArrowsAltH, FaArrowsAltV, FaMinus } from 'react-icons/fa';
import {
  ImArrowDown,
  ImArrowLeft,
  ImArrowRight,
  ImArrowUp,
} from 'react-icons/im';
import { BottomBarSelect } from '../components/BottomBarSelect';
import { ColorPickerField } from '../components/ColorPickerField';
import DynamicIcon from '../components/DynamicIcon';
import { IconField } from '../components/IconField';
import slate from '../packages/plugins/content/slate';

const defaultSlate = slate();

const bunkeringProcedurePlugin: any = {
  Renderer: ({ children, data }: any) => (
    <div
      className="bunkeringProcedure-outer"
      style={{
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        alignItems: 'center',
      }}
    >
      <div
        className="bunkering-proc-top"
        style={{
          fontSize: 32,
          height: 35,
          textAlign: 'center',
        }}
      >
        {data?.arrows?.top === 'Outgoing' && <ImArrowUp />}
        {data?.arrows?.top === 'Ingoing' && <ImArrowDown />}
        {data?.arrows?.top === 'Double headed' && <FaArrowsAltV />}
        {data?.arrows?.top === 'Simple line' && (
          <FaMinus style={{ rotate: '90deg' }} />
        )}
      </div>

      <div
        className="bunkering-proc-mid"
        style={{
          display: 'flex',
          width: '100%',
        }}
      >
        <div
          className="bunkering-proc-mid-left"
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 32,
            margin: '0 auto',
          }}
        >
          {data?.arrows?.left === 'Outgoing' && <ImArrowLeft />}
          {data?.arrows?.left === 'Ingoing' && <ImArrowRight />}
          {data?.arrows?.left === 'Double headed' && <FaArrowsAltH />}
          {data?.arrows?.left === 'Simple line' && <FaMinus />}
        </div>

        <div
          className="bunkeringProcedure-content"
          style={{
            display: 'flex',
            background: data?.style?.backgroundColor
              ? data?.style?.backgroundColor
              : '#fff',
            border: `3px solid ${
              data?.style?.borderColor ? data?.style?.borderColor : '#fff'
            }`,
            padding: '10px 15px',
            borderRadius: '30px',
            width: '100%',
            alignItems: 'center',
            margin: '0px',
          }}
        >
          {data?.style?.hideIcon ? null : (
            <div
              className="bunkeringProcedure-icon"
              style={{
                fontSize: '3rem',
                background: data?.style?.iconBackground,
                borderRadius: '50px',
                padding: '10px 10px 10px',
              }}
            >
              {' '}
              <DynamicIcon
                color={data?.style?.iconColor}
                iconName={data?.style?.icon ?? 'Valve'}
              />
            </div>
          )}
          <div
            className="bunkeringProcedure-text"
            style={{
              paddingLeft: 10,
              width: '90%',
              color: data?.style?.textColor,
              paddingRight: 10,
            }}
          >
            {children}
          </div>
        </div>

        <div
          className="bunkering-proc-mid-right"
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 32,
            margin: '0px auto',
          }}
        >
          {data?.arrows?.right === 'Outgoing' && <ImArrowRight />}
          {data?.arrows?.right === 'Ingoing' && <ImArrowLeft />}
          {data?.arrows?.right === 'Double headed' && <FaArrowsAltH />}
          {data?.arrows?.right === 'Simple line' && <FaMinus />}
        </div>
      </div>

      <div
        className="bunkering-proc-bottom"
        style={{
          fontSize: 32,
          height: 35,
          textAlign: 'center',
        }}
      >
        {data?.arrows?.bottom === 'Outgoing' && <ImArrowDown />}
        {data?.arrows?.bottom === 'Ingoing' && <ImArrowUp />}
        {data?.arrows?.bottom === 'Double headed' && <FaArrowsAltV />}
        {data?.arrows?.bottom === 'Simple line' && (
          <FaMinus style={{ rotate: '90deg' }} />
        )}
      </div>
    </div>
  ),
  createInitialChildren: () => {
    return [
      [
        {
          plugin: defaultSlate,
          data: defaultSlate.createData(({ plugins }) => ({
            children: [
              {
                plugin: plugins.headings.h1,
                children: ['Title'],
              },
              {
                plugin: plugins.headings.h3,
                children: ['Subtitle'],
              },
            ],
          })),
        },
      ],
    ];
  },

  id: 'bunkeringProcedure-plugin',
  title: 'Process Box Rounded',
  // description: 'emergency content plugin',
  version: 1,
  controls: [
    {
      title: 'Styling',
      controls: {
        type: 'autoform',
        schema: {
          type: 'object',
          required: [],
          properties: {
            style: {
              type: 'object',
              required: [],
              properties: {
                // headerSection: {
                //   type: 'string',
                //   uniforms: {
                //     component: () => (
                //       <div
                //         style={{
                //           display: 'flex',
                //           alignItems: 'center',
                //           justifyContent: 'flex-start',
                //           marginBottom: '15px',
                //           width: '100%',
                //         }}
                //       >
                //         <div
                //           style={{
                //             fontSize: '1.5rem',
                //             fontWeight: 'bold',
                //             textAlign: 'right',
                //             color: '#333',
                //           }}
                //         >
                //           Process Box Rounded
                //         </div>
                //       </div>
                //     ),
                //   },
                // },
                hideIcon: {
                  type: 'boolean',
                  default: false,
                },
                backgroundColor: {
                  type: 'string',
                  default: 'rgba(255,255,255,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Background Color: ',
                  },
                },
                borderColor: {
                  type: 'string',
                  default: 'rgba(255,255,255,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Border Color: ',
                  },
                },
                icon: {
                  type: 'string',
                  default: 'Valve',
                  uniforms: {
                    component: IconField,
                    label: 'Icon: ',
                  },
                },
                iconBackground: {
                  type: 'string',
                  default: 'transparent',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon Background Color: ',
                  },
                },
                iconColor: {
                  type: 'string',
                  default: 'rgba(0,0,0,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon color: (*where applicable) ',
                  },
                },
                textColor: {
                  type: 'string',
                  default: 'rgba(0,0,0,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Text Color: ',
                  },
                },
              },
            },
          },
        },
      },
    },
    {
      title: 'Arrows',
      controls: {
        type: 'autoform',
        schema: {
          type: 'object',
          required: [],
          properties: {
            arrows: {
              type: 'object',
              required: [],
              properties: {
                top: {
                  type: 'string',
                  uniforms: {
                    component: BottomBarSelect,
                    label: 'Top:',
                    defaultValue: 'None',
                    options: [
                      { key: 'None', value: 'None', label: 'None' },
                      { key: 'Outgoing', value: 'Outgoing', label: 'Outgoing' },
                      { key: 'Ingoing', value: 'Ingoing', label: 'Ingoing' },
                      {
                        key: 'Double headed',
                        value: 'Double headed',
                        label: 'Double headed',
                      },
                      {
                        key: 'Simple line',
                        value: 'Simple line',
                        label: 'Simple line',
                      },
                    ],
                  },
                },
                right: {
                  type: 'string',
                  uniforms: {
                    component: BottomBarSelect,
                    label: 'Right:',
                    defaultValue: 'None',
                    options: [
                      { key: 'None', value: 'None', label: 'None' },
                      { key: 'Outgoing', value: 'Outgoing', label: 'Outgoing' },
                      { key: 'Ingoing', value: 'Ingoing', label: 'Ingoing' },
                      {
                        key: 'Double headed',
                        value: 'Double headed',
                        label: 'Double headed',
                      },
                      {
                        key: 'Simple line',
                        value: 'Simple line',
                        label: 'Simple line',
                      },
                    ],
                  },
                },
                bottom: {
                  type: 'string',
                  uniforms: {
                    component: BottomBarSelect,
                    label: 'Bottom:',
                    defaultValue: 'None',
                    options: [
                      { key: 'None', value: 'None', label: 'None' },
                      { key: 'Outgoing', value: 'Outgoing', label: 'Outgoing' },
                      { key: 'Ingoing', value: 'Ingoing', label: 'Ingoing' },
                      {
                        key: 'Double headed',
                        value: 'Double headed',
                        label: 'Double headed',
                      },
                      {
                        key: 'Simple line',
                        value: 'Simple line',
                        label: 'Simple line',
                      },
                    ],
                  },
                },
                left: {
                  type: 'string',
                  uniforms: {
                    component: BottomBarSelect,
                    label: 'Left:',
                    defaultValue: 'None',
                    options: [
                      { key: 'None', value: 'None', label: 'None' },
                      { key: 'Outgoing', value: 'Outgoing', label: 'Outgoing' },
                      { key: 'Ingoing', value: 'Ingoing', label: 'Ingoing' },
                      {
                        key: 'Double headed',
                        value: 'Double headed',
                        label: 'Double headed',
                      },
                      {
                        key: 'Simple line',
                        value: 'Simple line',
                        label: 'Simple line',
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
  ],
};

export default bunkeringProcedurePlugin;
